import React from 'react';
import PropTypes from 'prop-types';

import Box from '@mui/material/Box';

import ThreadAnswer from './ThreadAnswer';

const ThreadAnswersList = (props) => {
  const {
    answers: pAnswers,
    loading: pLoading,
    onDeleteAnswer,
    onEditAnswer,
    onReportAnswer,
    onUpvoteAnswer,
    onDownvoteAnswer,
  } = props;

  const loading = pLoading && !pAnswers;
  const answers = loading ? Array.from(new Array(3)) : pAnswers;

  return (
    <Box display="flex" flexDirection="column" mt={2}>
      {answers?.map((answer, index) => (
        <ThreadAnswer
          key={index}
          answer={answer}
          loading={loading}
          onDeleteAnswer={onDeleteAnswer}
          onEditAnswer={onEditAnswer}
          onReportAnswer={onReportAnswer}
          onUpvoteAnswer={onUpvoteAnswer}
          onDownvoteAnswer={onDownvoteAnswer}
          isLast={index === answers?.length - 1}
        />
      ))}
    </Box>
  );
};

ThreadAnswersList.propTypes = {
  loading: PropTypes.bool,
  answers: PropTypes.array,

  onDeleteAnswer: PropTypes.func,
  onEditAnswer: PropTypes.func,
  onReportAnswer: PropTypes.func,
  onUpvoteAnswer: PropTypes.func,
  onDownvoteAnswer: PropTypes.func,
};

ThreadAnswersList.defaultProps = {
  loading: false,
  answers: undefined,

  onDeleteAnswer() {},
  onEditAnswer() {},
  onReportAnswer() {},
  onUpvoteAnswer() {},
  onDownvoteAnswer() {},
};

export default ThreadAnswersList;
